module.exports = __webpack_public_path__ + "static/media/pmgsl.61472a03.png";